export const MATCHES_LOAD = '@matches/load';
export const MATCHES_ADD = '@matches/add';
